/*
  Mobile menu panel. Drops out of the bottom edge of the header and is closed
  by the same hamburger that opened it (which renders as an X while open), or
  by Esc. The panel covers the viewport below the header, so there is no scrim
  to tap.

  The only measurement here is where the header ends: --orquis-nav-top is set
  from the header's own rect at open time, so the panel meets it whether the
  page is at the top, scrolled, or the announcement bar is absent.

  Markup: snippets/nav-drawer.liquid. Styling: the "Mobile menu" block in
  orquis.css.
*/
class NavDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = null;
    this.panel = this.querySelector('.orquis-nav__panel');
    this.grid = this.querySelector('.orquis-nav__grid');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.onResize = () => this.position();

    this.setupTrigger();
    this.setupFilters();
  }

  setupTrigger() {
    const trigger = document.querySelector('#menu-icon-bubble');
    if (!trigger) return;
    this.trigger = trigger;

    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle();
    });
  }

  /* Category pills, the same control the shop page uses. The list cross-fades
     rather than snapping so switching category reads as one movement. */
  setupFilters() {
    this.pills = Array.from(this.querySelectorAll('.orquis-nav__cat'));
    this.cards = Array.from(this.querySelectorAll('.orquis-nav__item'));
    if (!this.pills.length) return;

    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('is-active')) return;

        this.pills.forEach((p) => {
          const on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        const type = pill.dataset.type || '';
        this.grid?.classList.add('is-switching');
        setTimeout(() => {
          this.cards.forEach((card) => {
            /* `__featured` is the one pill that is not a product type: it is the
               featured collection (tag = new), matched on its own attribute. */
            const match = type === '__featured' ? card.dataset.featured === 'true' : card.dataset.type === type;
            card.hidden = type !== '' && !match;
          });
          this.grid?.classList.remove('is-switching');
        }, 180);
      });
    });
  }

  position() {
    const header = document.querySelector('.section-header');
    const bottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    this.style.setProperty('--orquis-nav-top', `${bottom}px`);
  }

  toggle() {
    this.classList.contains('active') ? this.close() : this.open(this.trigger);
  }

open(triggeredBy) {
  if (this.classList.contains('active')) return;
  if (triggeredBy) this.activeElement = triggeredBy;

  const header = document.querySelector('.section-header');

  // The mobile drawer must force the sticky header back into view.
  header?.classList.add('menu-open');

  // Measure AFTER the header has been restored, not before.
  this.position();

  this.trigger?.setAttribute('aria-expanded', 'true');

    // A frame's delay lets the browser register the class change as a
    // transition start, so the panel always unfolds instead of appearing.
    setTimeout(() => {
      this.classList.add('active');
      trapFocus(this.panel);
    });

    window.addEventListener('resize', this.onResize);
    // orquis-nav-open squares off the header card so it lines up with the
    // full-bleed panel hanging beneath it.
    document.body.classList.add('overflow-hidden', 'orquis-nav-open');
  }

  close() {
    if (!this.classList.contains('active')) return;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    window.removeEventListener('resize', this.onResize);
this.trigger?.setAttribute('aria-expanded', 'false');
const header = document.querySelector('.section-header');
header?.classList.remove('menu-open');
document.body.classList.remove('overflow-hidden', 'orquis-nav-open');
  }
}

customElements.define('nav-drawer', NavDrawer);
